var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "book_cover",
    class: [_vm.bookSize, _vm.kidCorver ? 'kid_corver' : '']
  }, [!_vm.to ? _c('div', {
    staticClass: "cover_img",
    class: _vm.coverType
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": _vm.alt
    }
  })]) : _c('router-link', {
    staticClass: "cover_img",
    class: _vm.coverType,
    attrs: {
      "to": _vm.to
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": _vm.alt
    }
  })])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }